/** Query param that keeps the native password form when `sso.onlySSO` is set. */
export const LOCAL_LOGIN_PARAM = 'local';
export const isAllowedSsoLoginUrl = (url) => {
    const trimmed = url.trim();
    if (!trimmed)
        return false;
    if (trimmed.startsWith('/') && !trimmed.startsWith('//'))
        return true;
    try {
        const parsed = new URL(trimmed);
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    }
    catch {
        return false;
    }
};
export const oidcAuthorizePath = (id) => `/api/openpeeps/core/v1/sso/oidc/${encodeURIComponent(id)}/authorize`;
export const ssoLoginDestinations = (sso) => {
    var _a, _b;
    const destinations = [];
    for (const provider of (_a = sso === null || sso === void 0 ? void 0 : sso.generic) !== null && _a !== void 0 ? _a : []) {
        destinations.push({
            href: provider.loginLink,
            name: provider.name,
            testId: `auth-login-generic-${provider.id}`,
        });
    }
    for (const provider of (_b = sso === null || sso === void 0 ? void 0 : sso.oidc) !== null && _b !== void 0 ? _b : []) {
        destinations.push({
            href: oidcAuthorizePath(provider.id),
            name: provider.name,
            testId: `auth-login-oidc-${provider.id}`,
        });
    }
    return destinations;
};
export const resolveOnlySsoView = (sso, searchParams) => {
    if (!(sso === null || sso === void 0 ? void 0 : sso.onlySSO) || searchParams.has(LOCAL_LOGIN_PARAM)) {
        return { mode: 'form' };
    }
    const destinations = ssoLoginDestinations(sso);
    const [only] = destinations;
    if (only && destinations.length === 1) {
        return { mode: 'redirect', href: only.href };
    }
    return { mode: 'chooser', destinations };
};
export const publicSsoInfo = (sso) => {
    const oidc = sso.oidc.map((provider) => ({
        id: provider.id,
        name: provider.name,
    }));
    const generic = sso.generic.flatMap((provider) => {
        var _a;
        const loginLink = (_a = provider.loginLink) === null || _a === void 0 ? void 0 : _a.trim();
        if (!loginLink || !isAllowedSsoLoginUrl(loginLink))
            return [];
        return [
            {
                id: provider.id,
                name: provider.name,
                loginLink,
            },
        ];
    });
    const onlySSO = !!sso.onlySSO;
    if (oidc.length === 0 && generic.length === 0 && !onlySSO) {
        return undefined;
    }
    return {
        oidc,
        generic,
        ...(onlySSO ? { onlySSO: true } : {}),
    };
};
